import React from "react";
import { Link } from "react-router-dom";
import { Heart, X } from "lucide-react";
import { toast } from "sonner";
import useSeo from "../hooks/useSeo";
import EmptyState from "../components/common/EmptyState";
import { useStore } from "../context/StoreProvider";
import { formatPrice } from "../lib/utils";

const Wishlist = () => {
  const { wishlistProducts, removeFromWishlist, addToCart } = useStore();
  useSeo({ title: "Wishlist", description: "Your saved 9'One Store pieces.", path: "/wishlist" });

  if (wishlistProducts.length === 0) {
    return (
      <div className="container-9one">
        <EmptyState
          icon={Heart}
          title="Your wishlist is empty"
          message="Tap the heart on any product to save it here."
          ctaLabel="Shop Now"
          ctaTo="/shop"
          testId="wishlist-empty"
        />
      </div>
    );
  }

  const quickAdd = (p) => {
    addToCart(p, { size: "M", color: p.colors[0]?.name, quantity: 1 });
    toast(`Added ${p.name} (Size M) — change size in cart or product page`);
  };

  return (
    <div className="container-9one py-12 animate-fade-in">
      <h1 className="mb-8 font-display text-5xl uppercase tracking-tight sm:text-6xl">
        Wishlist <span className="text-brand-dark">({wishlistProducts.length})</span>
      </h1>
      <div className="grid grid-cols-2 gap-x-4 gap-y-10 sm:grid-cols-3 lg:grid-cols-4" data-testid="wishlist-grid">
        {wishlistProducts.map((p) => (
          <div key={p.id} className="group relative" data-testid={`wishlist-item-${p.slug}`}>
            <Link to={`/product/${p.slug}`} className="block">
              <div className="relative aspect-[4/5] overflow-hidden bg-cream">
                <img src={p.images[0]} alt={p.name} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
              </div>
            </Link>
            <button
              onClick={() => removeFromWishlist(p.id)}
              aria-label="Remove from wishlist"
              data-testid={`wishlist-remove-${p.slug}`}
              className="absolute right-3 top-3 flex h-9 w-9 items-center justify-center bg-paper/90 backdrop-blur hover:bg-paper"
            >
              <X size={17} />
            </button>
            <div className="mt-3">
              <Link to={`/product/${p.slug}`}>
                <h3 className="truncate text-sm font-medium">{p.name}</h3>
              </Link>
              <p className="mt-0.5 font-mono text-sm text-ink/60">{formatPrice(p.price)}</p>
              <button onClick={() => quickAdd(p)} className="btn-outline mt-3 w-full py-2.5" data-testid={`wishlist-add-${p.slug}`}>
                Add to Cart
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Wishlist;
